<template>
    <div>
        <GChart
            type="ComboChart"
            :settings="{packages: ['corechart'], language: 'pt-br'}"
            :data="chartDataFinal"
            :options="chartOptions"
        />
    </div>
</template>

<script>
export default {
    props: ['chartData', 'currency'],
    data() {
        return {
            chartOptions: {
                fontName: 'Muli',
                height: 500,
                title: '',
                vAxis: {
                    title: this.__('reports.Results')
                },
                hAxis: {
                    title: this.__('reports.Odd')
                },
                seriesType: 'bars',
                series: {
                    2: {
                        type: 'line'
                    }
                }
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
}
</script>

<style scoped>

</style>
